import { useSyncExternalStore } from 'react';

/**
 * Debug mode (features/debug): the level's debug bar. On with `?debug` in the address, or the
 * switch on the debug page (#/debug), which remembers it on this device.
 */
const KEY = 'foe-names.debug';

function load(): boolean {
  if (new URLSearchParams(window.location.search).has('debug')) return true;
  try {
    return localStorage.getItem(KEY) === 'on';
  } catch {
    return false;
  }
}

let on = load();
const listeners = new Set<() => void>();

export const debugStore = {
  get: () => on,
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  set(next: boolean) {
    on = next;
    try {
      if (next) localStorage.setItem(KEY, 'on');
      else localStorage.removeItem(KEY);
    } catch {
      // Storage blocked: debug mode lasts for this visit.
    }
    for (const l of listeners) l();
  },
};

export function useDebug(): boolean {
  return useSyncExternalStore(debugStore.subscribe, debugStore.get);
}
